/* eslint-disable */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ProcessesIcon extends BaseIcon {
  getChildren = () => [ <g fill={ this.getColor() }>
    <rect x="2" y="5" width="2" height="3"/>
    <path d="M3,0A3,3,0,1,0,6,3,3,3,0,0,0,3,0ZM3,4A1,1,0,1,1,4,3,1,1,0,0,1,3,4Z"/>
    <rect x="7.5" y="1.5" width="2" height="3" transform="translate(11.5 -5.5) rotate(90)"/>
    <rect x="11" y="8" width="2" height="4" transform="translate(24 20) rotate(180)"/>
    <rect x="9.85" y="0.87" width="4.27" height="4.27" transform="translate(5.63 -7.59) rotate(45)"/>
    <rect y="10" width="5" height="5"/>
    <circle cx="12" cy="13" r="3"/>
  </g> ]
  getViewBox = () => '0 0 16 16'
}
